import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device } from 'src/app/models/device/device.model';
import { OwnerAuthorization, Plant } from 'src/app/models/plant/plant.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

const plantAPIVersion = "v3.0";


@Injectable()
export class RestPlantService extends BaseApiService {



  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

  //PLANT APIs

  deletePlant(id: string) {
    return this.httpClient.delete(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants/" + id, {headers: this.authService.eliotHttpHeaders});
  }

  createPlant(plant: Plant): Observable<Plant> {
    return this.httpClient.post<Plant>(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants", plant, {headers: this.authService.eliotHttpHeaders});
  }

  getPlantsList(): Observable<Plant[]> {
    return this.httpClient.get<Plant[]>(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants", {headers : this.authService.eliotHttpHeaders});
  }

  getPlant(id: string): Observable<Plant> {
    return this.httpClient.get<Plant>(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants/" + id, {headers : this.authService.eliotHttpHeaders});
  }

  updatePlant(plant: Plant): Observable<string> {
    return this.httpClient.patch<string>(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants/" + plant.id, plant, {headers : this.authService.eliotHttpHeaders});
  }

  getDeviceListByPlantId(id: string) : Observable<Device[]>{
    return this.httpClient.get<Device[]>(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants/" + id + "/modules");
  }

  inviteUserOnPlant(id: string, email: string) {
    let body = {
      language : "it"
    }
    return this.httpClient.post(super.getEliotApiHost()+ "servicecatalog/api/" + plantAPIVersion + "/plants/" + id + "/delegatedusers/" + email + "/", body, {headers : this.authService.eliotHttpHeaders});
  }

  removeUserFromPlant(id : string, email: string) {
    return this.httpClient.delete(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants/" + id + "/delegatedusers/" + email + "/", {headers : this.authService.eliotHttpHeaders});
  }

  changePlantOwner(id : string, email : string, body : OwnerAuthorization) : Observable<any> {

    return this.httpClient.post(super.getEliotApiHost() + "servicecatalog/api/" + plantAPIVersion + "/plants/" + id + "/owner/" + email +"/", body, {headers : this.authService.eliotHttpHeaders});
  }

}
